package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Radius
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import co.maytes.standupbot.shared.dto.billing.PlanLimitNudgeDto
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.dom.A

@Composable
fun UpgradeNudge(nudge: PlanLimitNudgeDto) {
    Row(
        modifier =
            Modifier
                .fillMaxWidth()
                .padding(topBottom = Spacing.sm, leftRight = Spacing.md)
                .gap(Spacing.md)
                .styleModifier {
                    property("background-color", "rgba(180, 83, 9, 0.10)")
                    property("border", "1px solid rgba(180, 83, 9, 0.28)")
                    property("border-radius", "${Radius.md}")
                    property("flex-wrap", "wrap")
                },
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Badge(label = "Free plan", tone = BadgeTone.Warning)
        Column(modifier = Modifier.styleModifier { property("flex", "1 1 200px") }) {
            SpanText(
                text = nudge.message,
                modifier =
                    Modifier
                        .fontSize(Typography.bodySmall.size)
                        .color(Palette.textSecondary),
            )
        }
        A(
            href = nudge.ctaUrl,
            attrs =
                Modifier
                    .padding(topBottom = Spacing.xs, leftRight = Spacing.md)
                    .color(Palette.onPrimary)
                    .fontSize(Typography.bodySmall.size)
                    .fontWeight(500)
                    .styleModifier {
                        property("background", Palette.primary.toString())
                        property("border-radius", "${Radius.full}")
                        property("text-decoration", "none")
                        property("white-space", "nowrap")
                    }
                    .toAttrs(),
        ) {
            SpanText("Upgrade →")
        }
    }
}
